"use strict";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('input[name="all"]').forEach((selectAllCheckbox) => {
        const form = selectAllCheckbox.closest("form");
        if (!form) return;

        const checkboxes = form.querySelectorAll('input[type="checkbox"]:not([name="all"])');

        selectAllCheckbox.addEventListener("change", (e) => {
            const isChecked = e.target.checked;
            checkboxes.forEach((checkbox) => {
                checkbox.checked = isChecked;
                checkbox.dispatchEvent(new Event("change"));
            });
        });

        checkboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", () => {
                const allChecked = Array.from(checkboxes).every(cb => cb.checked);
                selectAllCheckbox.checked = allChecked;
            });
        });
    });
});